export default __webpack_public_path__ + "static/Progress Bars-18cc3aef09d38192827b585c848ff4c9.png";